<template>
  <v-sheet color="grey-darken-4" theme="dark">
    <v-container>
      <v-row class="align-center justify-space-around flex-md-nowrap">
        <LogoLink
          :image="logoIcarGoldWhite"
          alt="I-CAR Gold Class"
          href="http://www.i-car.com/"
          scale="80%"
        />
        <LogoLink
          :image="logoAseCertifiedWhite"
          alt="ASE Certified"
          href="https://www.ase.com/"
          scale="60%"
        />
        <LogoLink
          :image="logoSpiesHeckerWhite"
          alt="Spies Hecker"
          href="https://www.spieshecker.com/"
          scale="60%"
        />
        <LogoLink
          :image="logoCarOLinerWhite"
          alt="Car-O-Liner"
          href="https://car-o-liner.com/"
          scale="100%"
        />
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
import logoAseCertifiedWhite from '#root/assets/logos/logo-ase-certified-white.png'
import logoCarOLinerWhite from '#root/assets/logos/logo-car-o-liner-white.png'
import logoIcarGoldWhite from '#root/assets/logos/logo-icargold-white.png'
import logoSpiesHeckerWhite from '#root/assets/logos/logo-spies-hecker-white.png'
</script>
